<template>
  <div style="padding-top: 120px">
    <!-- <img class="banner" v-lazy="'../../../static/banner/1/n_banner5.png'" /> -->
    <img class="banner" src="../../assets/banner/service.jpg" alt="" />
    <div class="content">
      <div>
        <div class="box">
          <div class="titleCont">
            <div>BUSINESS SYSTEM</div>
            <div>业务体系</div>
          </div>
          <div class="businesssystem">
            <div class="item" :key="index" v-for="(item, index) in tabList">
              <div class="top">
                <img :src="item.url" alt="" />
                <div class="name">{{ item.name }}</div>
              </div>
              <div class="bottom">
                <div :key="index1" v-for="(inner, index1) in item.list">
                  {{ inner }}
                </div>
              </div>
            </div>
          </div>
          <div class="titleCont">
            <div>SERVICE BENEFITS</div>
            <div>服务优势</div>
          </div>

          <div class="servicebenefits">
            <div class="item">
              <img src="../../assets/banner/3/8.jpg" alt="" />
            </div>
            <div class="item info">
              <div class="name">优质的IT服务</div>
              <div class="cont">
                节省企业70%IT成本，有效整合同行优质资源，能为企业提供统—管控、统一服务、统—标准的高性价比IT服务，节省企业70%IT运营成本。
              </div>
            </div>

            <div class="item info">
              <div class="name">高效的项目管理</div>
              <div class="cont">
                通过明确目标、采用敏捷方法、合理分配资源、管理风险、保持沟通、确保质量以及灵活应对变化等手段，项目团队能够在复杂的环境中保持高效运转，最终成功交付符合预期的产品。
              </div>
            </div>
            <div class="item">
              <img src="../../assets/banner/3/9.jpg" alt="" />
            </div>
            <div class="item">
              <img src="../../assets/banner/3/10.jpg" alt="" />
            </div>
            <div class="item info">
              <div class="name">完善的售后体系</div>
              <div class="cont">
                建立多渠道支持系统，及时响应并解决客户问题，拥有专业化的技术团队，能够处理各种复杂的技术问题。采用主动跟进与反馈机制，持续监控、追踪服务进程，为企业提供及时的售后服务支持。
              </div>
            </div>
          </div>

          <div class="titleCont">
            <div>DEVELOPMENT PROCESS</div>
            <div>开发流程</div>
          </div>
          <div class="developmentProcess">
            <div class="item one">
              <div class="boxes">
                <div class="num">01</div>
                <div class="name">项目沟通</div>
                <div class="desc">
                  <div>初步项目需求交流</div>
                  <div>框架功能设计</div>
                </div>
              </div>
              <div class="line"></div>
              <div class="boxes">
                <div class="num">02</div>
                <div class="name">项目启动</div>
                <div class="desc">
                  <div>合同签订确定</div>
                  <div>项目执行团队</div>
                </div>
              </div>
            </div>
            <div class="item two">
              <div class="boxes">
                <div class="num">03</div>
                <div class="name">产品设计</div>
                <div class="desc">
                  <div>产品原型设计</div>
                </div>
              </div>
              <div class="line"></div>
              <div class="boxes">
                <div class="num">04</div>
                <div class="name">UI设计</div>
                <div class="desc">
                  <div>UI效果图渲染设计</div>
                  <div>配色设计、切图</div>
                </div>
              </div>
            </div>
            <div class="item three">
              <div class="boxes">
                <div class="num">05</div>
                <div class="name">详细设计</div>
                <div class="desc">
                  <div>数据库设计</div>
                  <div>系统框架设计</div>
                </div>
              </div>
              <div class="line"></div>
              <div class="boxes">
                <div class="num">06</div>
                <div class="name">敏捷开发</div>
                <div class="desc">
                  <div>每周迭代功能</div>
                  <div>核对开发进度</div>
                </div>
              </div>
            </div>
            <div class="item four">
              <div class="boxes">
                <div class="num">07</div>
                <div class="name">集成测试</div>
                <div class="desc">
                  <div>整体集成测试 </div>
                  <div>用户场景测试</div>
                </div>
              </div>
              <div class="line"></div>
              <div class="boxes">
                <div class="num">08</div>
                <div class="name">验收上线</div>
                <div class="desc">
                  <div>系统设计</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerTitle from "../common/banner-title";

export default {
  name: "product",
  data() {
    return {
      cur: 0,
      // active:0,
      tabList: [
        {
          name: "网站建设",
          url: require("../../assets/banner/3/2.png"),
          list: [
            "企业管理系统（ERP）",
            "客户关系管理（CRM）",
            "定制化应用开发",
          ],
        },
        {
          name: "移动应用开发",
          url: require("../../assets/banner/3/3.png"),
          list: ["原生应用开发", "跨平台开发"],
        },
        {
          name: "H5微营销",
          url: require("../../assets/banner/3/4.png"),
          list: ["微信公众号托管", "微应用定制开发", "微信市场引流"],
        },
        {
          name: "大数据与数据分析",
          url: require("../../assets/banner/3/5.png"),
          list: ["数据挖掘与分析", "商业智能（BI）", "数据集成与管理"],
        },
        {
          name: "数字化解决方案",
          url: require("../../assets/banner/3/6.png"),
          list: ["数字化规划", "业务流程变革"],
        },
        {
          name: "AI人工智能",
          url: require("../../assets/banner/3/7.png"),
          list: ["计算机视觉", "机器学习"],
        },
      ],
      flag1: false,
      flag2: false,
    };
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrolling);
  },

  components: {
    BannerTitle,
  },
  created() {
    this.cur = this.$route.query.id || 0;
    window.addEventListener("scroll", this.scrolling);
  },

  methods: {
    changeTab(item, index1) {
      this.cur = index1;
    },
    scrolling(e) {
      const winHeight =
        e.target.scrollTop || document.documentElement.scrollTop;
      console.log(winHeight, 4444444444);
      if (winHeight >= 100) {
        this.flag1 = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.titleCont {
  padding: 120px 0 99px;
  > div:first-child {
    font-family: Arial;
    font-weight: normal;
    font-size: 30px;
    color: #333333;
    line-height: 24px;
    margin-bottom: 36px;
    text-align: center;
  }
  > div:last-child {
    text-align: center;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 30px;
    color: #333333;
  }
}
.banner {
  display: block;
  width: 100%;
}

.content {
  min-height: 400px;
  background: #fff;
  display: flex;
  justify-content: space-around;

  .box {
    width: 80rem;
    margin: 0 auto;
    .businesssystem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        margin-bottom: 65px;
        height: 312px;
        background: #ffffff;
        box-shadow: 0px 0px 18px 0px rgba(66, 15, 0, 0.08);
        width: 30%;
        &:nth-child(3n -1) {
          margin: 0 5%;
          margin-bottom: 65px;
        }
        .top {
          height: 183px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          background: url("../../assets/banner/3/1.jpg") no-repeat;
          background-size: cover;
          img {
            width: 86px;
            height: 86px;
          }
          .name {
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 22px;
            color: #090909;
            line-height: 16px;
            margin-top: 24px;
          }
        }
        .bottom {
          padding: 18px 0 0;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #090909;
          text-align: center;
          > div {
            margin-bottom: 13px;
          }
        }
      }
    }
    .servicebenefits {
      padding-bottom: 120px;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        // height: 400px;
        img {
          width: 100%;
          display: block;
        }
        &.info {
          background: #f3f4f8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .name {
            padding: 0 97px 0 81px;
            margin-bottom: 50px;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 22px;
            color: #090909;
            line-height: 30px;
          }
          .cont {
            padding: 0 97px 0 81px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #090909;
            line-height: 30px;
          }
        }
      }
    }
    .developmentProcess {
      display: flex;
      align-items: center;
     
      padding-bottom: 120px;
      .item {
        height: 600px;
        flex: 1;
        padding-top: 68px;
        display: flex;
        flex-direction: column;
        text-align: center;
        // align-items: center;
        
        &.one {
          background: url("../../assets/banner/3/11.jpg") no-repeat;
          background-size: cover;
        }
        &.two {
          background: url("../../assets/banner/3/12.jpg") no-repeat;
          background-size: cover;
        }
        &.three {
          background: url("../../assets/banner/3/13.jpg") no-repeat;
          background-size: cover;
        }
        &.four {
          background: url("../../assets/banner/3/14.jpg") no-repeat;
          background-size: cover;
        }
        .line {
          width: 2px;
          height: 62px;
          background: #fe7e00;
          margin: 44px auto;
        }

        .boxes {
          .num {
            font-family: Ebrima;
            font-weight: 400;
            font-size: 40px;
            color: #ffffff;
            line-height: 33px;
          }
          .name {
            margin: 36px 0 31px;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 22px;
            color: #ffffff;
            line-height: 16px;
          }
          .desc {
            min-height: 52px;
            font-family: PingFang SC;
font-weight: 500;
font-size: 18px;
color: #FFFFFF;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/index.vue